import { DateField } from "./DateField";
import { TimeField } from "./TimeField";
import type { DateAndTime } from "@core/utils";

interface DateTimeFieldProps {
  /** Label of the date (« Ouverture »). */
  label: string;
  /** Label of the time (« Heure »). */
  timeLabel: string;
  /** The date (`2026-11-15`) and the time (`09:00`), each `""` while not entered. */
  value: DateAndTime;
  onChange: (value: DateAndTime) => void;
  onBlur?: () => void;
  isDisabled?: boolean;
  /** Shown under the date. */
  errorMessage?: string;
  /** Shown under the time. */
  timeErrorMessage?: string;
}

/**
 * A date and a time on one row (Figma « Créer un appel »: Ouverture and Heure, Clôture and Heure):
 * the date picker, wide, and a 24-hour time, narrow. The value is the two parts as typed; turn
 * them into the instant the API wants with `toAlgiersIso`, which fixes Algeria time in one place.
 */
export function DateTimeField({
  label,
  timeLabel,
  value,
  onChange,
  onBlur,
  isDisabled,
  errorMessage,
  timeErrorMessage,
}: DateTimeFieldProps) {
  return (
    <div className="grid grid-cols-[minmax(0,1fr)_8rem] items-start gap-md">
      <DateField
        label={label}
        value={value.date}
        onChange={(date) => {
          onChange({ ...value, date });
        }}
        onBlur={onBlur}
        isDisabled={isDisabled}
        errorMessage={errorMessage}
      />
      <TimeField
        label={timeLabel}
        value={value.time}
        onChange={(time) => {
          onChange({ ...value, time });
        }}
        onBlur={onBlur}
        isDisabled={isDisabled}
        errorMessage={timeErrorMessage}
      />
    </div>
  );
}

export type { DateTimeFieldProps };
